import script from "./TransactionContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionContent.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionContent.vue?vue&type=style&index=0&id=24b12987&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b12987"]])

export default __exports__